import { DashboardWidgetType } from '../model';
import { dashboardWidgetRegistry, type DashboardWidgetRendererProps } from '../widgetRegistry';
import { dashboardWidgetWidthClassName } from '@/components/dashboard/DashboardCanvas';

export function DashboardWidgetRenderer(
  props: DashboardWidgetRendererProps & { withLayout?: boolean },
) {
  const definition = dashboardWidgetRegistry[props.widget.type] as
    (typeof dashboardWidgetRegistry)[keyof typeof dashboardWidgetRegistry] | undefined;
  if (!definition) return null;
  if (!definition.schema.safeParse(props.widget).success) return null;
  const Component = definition.component;
  const content = <Component {...props} />;
  if (props.withLayout === false) return content;
  return (
    <div
      className={dashboardWidgetWidthClassName(
        props.widget.width,
        props.widget.type === DashboardWidgetType.Metric,
      )}
      data-widget-id={props.widget.id}
    >
      {content}
    </div>
  );
}
